// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"652":"1fe24894","4081":"81aa26c2","4522":"1fe24894","5242":"5be1fd42","5779":"5fff5ebb"}[chunkId] + ".chunk.css";
};